import { FilterOutlined } from "@ant-design/icons"
import { Button } from "antd"
import { Store } from "antd/lib/form/interface"
import { FilterModalLegacy } from "Components/filter/FilterModalLegacy"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { TablesEnum } from "Shared/store/reducers/tableConfigReducer"
import { FilterSectionOptionsInterface } from "./filterTypes"

interface FilterProps {
    table: TablesEnum
    options: FilterSectionOptionsInterface
    onFilter: (filterData: Store) => Promise<void>
}

/**
 * @deprecated Use only for old redux-based tables.
 */
export const FilterLegacy = ({ table, options, onFilter }: FilterProps) => {
    const { t } = useTranslation()

    const [isFilterModalShowing, setIsFilterModalShowing] = useState(false)

    return (
        <>
            <FilterModalLegacy table={table} options={options} isVisible={isFilterModalShowing} onCancel={setIsFilterModalShowing} onSubmit={onFilter} />

            <Button type="default" className="w-100" onClick={() => setIsFilterModalShowing(true)}>
                <FilterOutlined />
                {t("action:filter")}
            </Button>
        </>
    )
}
